// Santo Domingo Motors - logo oficial (PNG desde assets)
import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_motor-crm-hub/artifacts/ba0s1x41_logo%20SDM.png";

export default function SdmLogo({ size = 56, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Santo Domingo Motors"
      className={`inline-block object-contain ${className}`}
      style={{ width: size, height: "auto" }}
    />
  );
}
